// extracted by mini-css-extract-plugin
export default {"storychestColor":"#dc3151","forgotPasswordLink":"login_forgotPasswordLink__k3TQg","appStoreBgImage":"login_appStoreBgImage__oZum6"};